// Único filtro de ?next para login, cadastro e buildLoginUrl (VH-190): só caminho interno.
// O parser de URL trata `\` como `/` e ignora TAB/CR/LF, então `/\evil` e `/<TAB>/evil`
// resolvem para outro domínio mesmo começando com `/` e sem `//`.
const ORIGEM_FALSA = 'https://x.invalid'

export function isSafeInternalPath(raw: string): boolean {
  if (!raw.startsWith('/') || raw.startsWith('//')) return false
  for (const ch of raw) {
    if (ch === '\\' || ch.charCodeAt(0) < 0x20 || ch.charCodeAt(0) === 0x7f) return false
  }
  try {
    return new URL(raw, ORIGEM_FALSA).origin === ORIGEM_FALSA
  } catch {
    return false
  }
}

export function safeNext(raw: string | null): string {
  return raw && isSafeInternalPath(raw) ? raw : '/buscar'
}
